import { TextSize, TextWeight } from 'adaptivecards'
import MarkdownIt from 'markdown-it'
import React, { useEffect, useState } from 'react'
import { capitalizeFirstLetter } from '../../utils/capitalizeFirstLetter'

interface TextBlockProps {
  text?: string
  isTitle?: boolean
  isSubtitle?: boolean
  size?: number
  weight?: TextWeight
  horizontalAlignment?: number
  wrap?: boolean
  maxLines?: number
}

const md = new MarkdownIt({
  breaks: true,
  html: true,
  xhtmlOut: true,
  linkify: false,
  typographer: true,
  quotes: `""''`
})

const getSizeFromEnum = (size: number): string => {
  switch (size) {
    case TextSize.Small:
      return 'rf-small-size-auto'
    case TextSize.Medium:
      return 'rf-text-medium-size-auto'
    case TextSize.Large:
      return 'rf-text-large-size-auto'
    case TextSize.ExtraLarge:
      return 'rf-text-extralarge-size-auto'
    case TextSize.Default:
    default:
      return 'rf-text-size-auto'
  }
}

const TextBlock = ({ text, isTitle, isSubtitle, size, weight, horizontalAlignment, wrap, maxLines }: TextBlockProps): JSX.Element => {
  const [style, setStyle] = useState<string>('')

  useEffect(() => {
    if (text) {
      // Text size
      let styleToApply = isTitle ? 'rf-title-size-auto' : isSubtitle ? 'rf-subtitle-size-auto' : size ? getSizeFromEnum(size) : 'rf-text-size-auto'

      // Text horizontal alignment
      if (horizontalAlignment) {
        switch (horizontalAlignment) {
          case 1:
            styleToApply += ' rf-text-center'
            break
          case 2:
            styleToApply += ' ltr:rf-text-right rtl:rf-text-left'
            break
          case 0:
          default:
            styleToApply += ' ltr:rf-text-left rtl:rf-text-right'
            break
        }
      } else {
        styleToApply += ' ltr:rf-text-left rtl:rf-text-right'
      }

      // Wrap ?
      wrap ? (isTitle || isSubtitle) && (styleToApply += ' rf-line-clamp-2') : (styleToApply += ' rf-truncate')

      // Max lines ? If this is a title it has already been set to 2 lines if wrap is not false
      !isTitle && maxLines && maxLines > 0 && maxLines <= 10 && (styleToApply += ` rf-line-clamp-${maxLines}`)

      switch (weight) {
        case TextWeight.Lighter:
          styleToApply += ' rf-font-light'
          break
        case TextWeight.Bolder:
          styleToApply += ' rf-font-bold'
          break
        case TextWeight.Default:
        default:
          break
      }

      setStyle(styleToApply)
    }
  }, [])

  return (
    <div
      className={`rf-w-full rf-text-cardFrameText ${style}`}
      dangerouslySetInnerHTML={{
        __html: text ? capitalizeFirstLetter(md.render(text)) : '\u00a0'
      }}
    />
  )
}

export default TextBlock
